import { useEffect, useState } from 'react';
import TController from './components/view/TController';

import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../../components/ui/ChildHeader';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import { useQuery } from '../../../hooks/UseQuery';
import ModalCustom from '../../../components/common/Modal';
import useConfirm from '../../../components/common/useConfirm';
import { constants } from './constant';
import PartTable from './components/PartTable';
import LocationTableModal from './components/LocationTableModal';

const View = () => {
  const [data, setData] = useState<any>({
    head: {
      isReportLocked: false,
      isSubmitted: false,
      mrr_date: new Date(),
    },
    processes: [],
  });
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [partIdx, setPartIdx] = useState<number>(0);
  const [isLoactionPopup, setIsLocationOpenPopup] = useState(false);
  const [locationIdx, setLocationIdx] = useState<number>(0);
  // const [isLockedReport, setIsLockedReport] = useState(false);
  const { supplierId, id } = useParams();

  const navigate = useNavigate();
  const [apiRender, setApiRender] = useState(false);
  const isView = useQuery('isView') === 'true' ? true : false;

  const [DialogDeleteRow, confirmDeleteRow] = useConfirm(
    'DELETE',
    'Are you sure you want to delete Row?'
  );
  const [DialogAddRow, confirmAddRow] = useConfirm(
    'Add Row',
    'Are you sure you want to Add Row?'
  );
  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to Submit this document? If you submit it you will not be able to modify it again.If you want to modify this doc then click the save button'
  );
  const [DialogSave, confirmSave] = useConfirm(
    'save',
    'Are you sure you want to save this document?'
  );

  // const isReportLockedFn = (isView: Boolean, isReportLocked: Boolean) => {
  //   if (isView === true) return true;
  //   if (isReportLocked === true) return true;
  //   return false;
  // };
  const handleSumbit = async (isSubmit: boolean) => {
    if (isSubmit) {
      const ans = await confirmSubmit();
      if (!ans) return;
    } else {
      const ans = await confirmSave();
      if (!ans) return;
    }
    if (!data?.head?.mrr_no || !data?.head?.mrr_date) {
      alert('MRR No and MRR Date is required');
      return;
    }
    data.head.isSubmitted = isSubmit;
    data.head.isReportLocked = isSubmit;
    if (id) {
      await axios
        .put(`${constants.api.crud}/${id}`, data)
        .then((res) => {
          if (res?.data?.status === 'failed') {
            setData((prev: any) => {
              return {
                ...prev,
                head: {
                  ...prev.head,
                  isSubmitted: false,
                  isReportLocked: false,
                },
              };
            });
            alert(res?.data?.msg);
            return;
          }
          if (res.data.status === 'success') {
            alert('Updated Successfully');
            setApiRender((prev) => !prev);
          }
        })
        .catch((err) => console.log(err));
    } else {
      data.head.supplier_id = supplierId;
      await axios
        .post(`${constants.api.crud}`, data)
        .then((res) => {
          if (res?.data?.status === 'failed') {
            setData((prev: any) => {
              return {
                ...prev,
                head: {
                  ...prev.head,
                  isSubmitted: false,
                  isReportLocked: false,
                },
              };
            });
            alert(res?.data?.msg);
            return;
          }
          if (res.data.status === 'success') {
            alert('created Successfully');
            navigate(-1);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    if (id) {
      axios
        .get(`${constants.api.crud}/${id}`)
        .then((res) => {
          if (res?.data) {
            setData(res.data);
          }
        })
        .catch((err) => {
          // setIsLoading(false);
          console.log(err);
        });
    } else {
      axios
        .get(`${constants.api.crud}/generateUniqueId`)
        .then((res) => {
          setData((prev: any) => ({
            head: {
              // mrr_no: res?.data?.newUniqueId,
              mrr_no: '',
              isReportLocked: false,
              isSubmitted: false,
              mrr_date: new Date(),
            },
            processes: [],
          }));
        })
        .catch((err) => console.log(err));
    }
  }, [id, apiRender]);

  const handleAddRow = async () => {
    const ans = await confirmAddRow();
    if (!ans) return;
    let values = { ...data };
    values.processes.push({
      no_of_pkt_per_pcs: null,
      uom: '',
      total_qty: null,
      ok_qty: null,
      rej_qty: null,
      status: '',
      location: [],
    });
    setData(values);
  };

  const handelDeleteRows = async (rowIdx: number) => {
    const ans = await confirmDeleteRow();
    if (!ans) return;

    setData((prev: any) => {
      const filteredData = prev.processes.filter(
        (_: any, i: number) => i !== rowIdx
      );
      const values = {
        head: { ...prev.head },
        processes: filteredData,
      };
      return values;
    });
  };

  const handleChangeRow = (e: any, index: number) => {
    const { name, value } = e.target;
    setData((prev: any) => {
      // shwallow copy of moduledata
      const values: any = { ...prev };

      // required ***** shwallow copy for object in arrays so that it can compare old values
      const upadatRows = { ...values.processes[index] }; // this line
      upadatRows[name] = value;
      // for calculation of rej qty
      if (name === 'total_qty' || name === 'ok_qty') {
        upadatRows['rej_qty'] = upadatRows['total_qty'] - upadatRows['ok_qty'];
      }
      // end of calculation
      values.processes[index] = upadatRows;
      return values;
    });
  };
  const handleChangeHead = (e: any) => {
    const { name, value } = e.target;
    const values: any = { ...data };
    values['head'][name] = value;
    setData(values);
  };

  const removePart = () => {
    handleChangeRow({ target: { name: 'ri_part_id', value: '' } }, partIdx);
    handleChangeRow({ target: { name: 'partName', value: '' } }, partIdx);
    handleChangeRow({ target: { name: 'partNumber', value: '' } }, partIdx);
  };

  const addPart = (item: any) => {
    handleChangeRow(
      { target: { name: 'ri_part_id', value: item._id } },
      partIdx
    );
    handleChangeRow(
      { target: { name: 'partName', value: item.part_name } },
      partIdx
    );
    handleChangeRow(
      { target: { name: 'partNumber', value: item.part_number } },
      partIdx
    );
    setIsOpenPopup(false);
  };

  const openModal = (index: any) => {
    setIsOpenPopup(true);
    setPartIdx(index);
  };

  const handleModalForLocation = (index: any) => {
    setIsLocationOpenPopup(true);
    setLocationIdx(index);
  };

  const handleSaveTableData = (data: any) => {
    handleChangeRow({ target: { name: 'location', value: data } }, locationIdx);
    setIsLocationOpenPopup(false);
  };

  return (
    <>
      <Box>
        <ChildHeader text={constants.moduleName}>
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#1c7ed6',
                }}
                disabled={data?.head?.isSubmitted}
                onClick={async () => {
                  handleAddRow();
                }}
              >
                ADD ROWS
              </CustomButton>

              <SaveButton
                label="Save"
                disabled={data?.head?.isSubmitted}
                onClick={() => handleSumbit(false)}
              />
              <SubmitButton
                label="Submit"
                disabled={data?.head?.isSubmitted}
                onClick={() => handleSumbit(true)}
              />
              {/* {!data.head.isSubmitted && <></>} */}
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          data,
          handleChangeRow,
          handleChangeHead,
          handelDeleteRows,
          isView,
          openModal,
          removePart,
          handleModalForLocation,
        }}
      />

      <DialogDeleteRow isSubmitContent={false} />
      <DialogAddRow />
      <DialogSubmit />
      <DialogSave />
      <ModalCustom
        title="Part List"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
        }}
      >
        <PartTable
          removepart={() => removePart()}
          addPart={(item: any) => addPart(item)}
          data={data.processes[partIdx]}
          {...{ supplierId }}
        />
      </ModalCustom>
      <ModalCustom
        title="Location"
        openModal={isLoactionPopup}
        closeModal={() => {
          setIsLocationOpenPopup(false);
        }}
      >
        <LocationTableModal
          {...{ handleSaveTableData, setIsLocationOpenPopup }}
          initialData={
            data?.processes?.[locationIdx]?.location?.length > 0
              ? [...data?.processes?.[locationIdx]?.location]
              : null
          }
          okQty={
            data?.processes?.[locationIdx]?.ok_qty
              ? data?.processes?.[locationIdx]?.ok_qty
              : null
          }
        />
      </ModalCustom>
    </>
  );
};

export default View;
